export const getProductStatus = (status: TaxonomyTermStatus, statusLink: LinkProps) => {
  const productStatus = {
    name: status.name,
    variant: status.variant,
    link: statusLink,
  };

  return [productStatus];
};
